import React from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { OOI_EXPERIMENTS } from '@app/experiments';
import { getCategories } from '../../store/categories/categories-selectors';
import ChangeCategory from '../categories-link';
import CategoryDrawer from '../categories-link/category-drawer';
import { HeaderMobile } from '../header';
import { useSelector } from '../runtime-context';

const CategoryMobileHeader = () => {
  const { experiments } = useExperiments();
  const categories = useSelector(getCategories);

  if (categories.length) {
    return (
      <HeaderMobile
        menu={
          experiments.enabled(OOI_EXPERIMENTS.MOBILE_DRAWER_FOR_CATEGORIES) ? (
            <CategoryDrawer />
          ) : (
            <ChangeCategory />
          )
        }
      />
    );
  }

  return <HeaderMobile />;
};

export default CategoryMobileHeader;
